import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Building2, Receipt, Percent, BookOpen, ShoppingCart, TrendingUp, TrendingDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AccountsDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/accounts/dashboard`).then(r => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="text-gray-400 text-center py-12">Loading...</div>;

  const cards = [
    { label: "Customers", value: stats.customers, icon: Users, color: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/30" },
    { label: "Vendors", value: stats.vendors, icon: Building2, color: "text-orange-400", bg: "bg-orange-500/10 border-orange-500/30" },
    { label: "Tax Rates", value: stats.tax_rates, icon: Percent, color: "text-purple-400", bg: "bg-purple-500/10 border-purple-500/30" },
    { label: "Voucher Types", value: stats.voucher_types, icon: Receipt, color: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30" },
  ];

  const voucherCards = [
    { label: "Sales", value: stats.sales_count, amount: stats.sales_total, icon: TrendingUp, color: "text-green-400", bg: "bg-green-500/10 border-green-500/30" },
    { label: "Purchase", value: stats.purchase_count, amount: stats.purchase_total, icon: ShoppingCart, color: "text-blue-400", bg: "bg-blue-500/10 border-blue-500/30" },
    { label: "Credit Notes", value: stats.credit_note_count, icon: TrendingDown, color: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
    { label: "Debit Notes", value: stats.debit_note_count, icon: BookOpen, color: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
  ];

  return (
    <div className="space-y-6" data-testid="accounts-dashboard">
      <div>
        <h2 className="text-2xl font-bold text-blue-400">Accounts Dashboard</h2>
        <p className="text-gray-400 text-sm mt-1">Sales & Purchase overview</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map(c => {
          const Icon = c.icon;
          return (
            <Card key={c.label} className={`border ${c.bg}`}>
              <CardContent className="p-4 text-center">
                <Icon className={`h-6 w-6 mx-auto mb-2 ${c.color}`} />
                <div className={`text-2xl font-bold ${c.color}`}>{c.value}</div>
                <div className="text-xs text-gray-400 mt-1">{c.label}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {voucherCards.map(c => {
          const Icon = c.icon;
          return (
            <Card key={c.label} className={`border ${c.bg}`}>
              <CardContent className="p-4 text-center">
                <Icon className={`h-6 w-6 mx-auto mb-2 ${c.color}`} />
                <div className={`text-2xl font-bold ${c.color}`}>{c.value}</div>
                <div className="text-xs text-gray-400 mt-1">{c.label}</div>
                {c.amount !== undefined && (
                  <div className="text-sm text-gray-300 mt-1 font-mono">
                    {new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(c.amount)}
                  </div>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default AccountsDashboard;
